import { useAppDispatch } from '@/shared/lib/redux'
import {
    openDeleteGroupModal as openDeleteGroupModalAction,
    openCreateGroupModal as openCreateGroupModalAction,
    openGroupAccrualModal as openGroupAccrualModalAction,
    openVisibilityAclModal as openVisibilityAclModalAction
} from '../../model'
import { RoleType } from '@/shared/api/users'
import { TargetType } from '@/shared/api/groups'
import { IGroup } from '@/shared/api/groups'
import { IUser } from '@/shared/api/users'

export const useUpdateGroupModal = () => {
    const dispatch = useAppDispatch()

    const openGroupAccrualModal = (groupId: string, onAccrual?: () => void) => {
        dispatch(openGroupAccrualModalAction({
            data: {
                id: groupId
            },
            onAccrual
        }))
    }
    const openDeleteGroupModal = (groupId: string, role: RoleType, onDelete?: () => void) => {
        dispatch(openDeleteGroupModalAction({
            data: {
                id: groupId
            },
            role,
            onDelete
        }))
    }

    const openCreateGroupModal = (role: RoleType, onCreate?: () => void) => {
        dispatch(openCreateGroupModalAction({
            role,
            onCreate
        }))
    }

    const openVisibilityAclModal = (
        data: Pick<IGroup, 'id'> | Pick<IUser, 'id'>,
        sourceType: TargetType,
        onVisibilityAclChange?: () => void
    ) => {
        dispatch(openVisibilityAclModalAction({
            data,
            sourceType,
            onVisibilityAclChange
        }))
    }
    
    return {
        openCreateGroupModal,
        openDeleteGroupModal,
        openGroupAccrualModal,
        openVisibilityAclModal
    }
}